import { SuperAdminSitemap } from './SuperAdminSitemap';
// import { ManagerSitemap } from './ManagerSitemap';
// import { checkerSitemap } from './checkerSitemap';
// import { payerRoutes } from './payerSitemap';

const getRoute = async ({ role }) => {
  console.log('🚀 ~ getRoute ~ role:', role);
  // Add type annotation for role parameter
  return SuperAdminSitemap();
  // switch (role) {
  //   case 'SuperAdmin':
  //     return SuperAdminSitemap();
  //   case 'Payer':
  //     // return payerRoutes;
  //     return [];
  //   case 'Manager':
  //     // return ManagerSitemap;
  //     return [];
  //   case 'Checker':
  //     // return checkerSitemap();
  //     return [];
  //   default:
  //     return [];
  // }
};

export default getRoute;
